import React, { useEffect } from 'react';
import { Landing } from './pages/Landing';
import { initMetaPixel } from './utils/metaPixel';
const INTERACTION_EVENTS = ['pointerdown', 'keydown', 'scroll', 'touchstart'] as const;
export function App() {
  useEffect(() => {
    let started = false;
    const start = () => {
      if (started) return;
      started = true;
      INTERACTION_EVENTS.forEach(event => window.removeEventListener(event, start));
      window.clearTimeout(timer);
      initMetaPixel();
    };
    const timer = window.setTimeout(start, 3500);
    INTERACTION_EVENTS.forEach(event => window.addEventListener(event, start, {
      once: true,
      passive: true
    }));
    return () => {
      window.clearTimeout(timer);
      INTERACTION_EVENTS.forEach(event => window.removeEventListener(event, start));
    };
  }, []);
  return <Landing data-id="element-0" data-mp="28te3zgj4jfoo" />;
}